export var TradingPageChartData = {
    data(){
        return{
            line_graph_legend: {
                type: 'scroll',
                itemGap : 20,
                top: 10,
                show: true,
            },

            line_chart_legends: [],

            verified_knowledge_chart_colors: ['#ff5059', '#33bb6d', '#2488ff'],

            verified_knowledge_chart_series: [
                {
                    name: 'Buy',
                    type: 'bar',
                    stack: 1,
                    data: [10, 20, 25, 45, 66, 78],
                    itemStyle: {
                        color: '#33bb6d'
                    }
                },
                {
                    name: 'Sell',
                    type: 'bar',
                    stack: 1,
                    data: [13, 23, 20, 38, 70, 65],
                    itemStyle: {
                        color: '#ff5059'
                    }
                },
                {
                    name: 'Hold',
                    type: 'line',
                    data: [11, 3, 27, 33, 65, 80],
                    itemStyle: {
                        color: '#2488ff'
                    }
                }
            ],

            verified_knowledge_chart_yaxis: {
                type: 'value',
                axisTick: {
                    show: false,
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: '#ddd',
                        width: 1 ,
                        type: 'solid'
                    },
                },
                axisLabel: {
                    fontSize: 11,
                    fontStyle: 'normal',
                    fontWeight: 500 ,
                    fontFamily: 'Montserrat',
                    color: '#7a7a7a',
                    margin: 10,
                    formatter: '{value} %'
                },
                splitLine: {
                    show: false
                },
            },

            verified_knowledge_chart_xaxis:{
                axisTick: {
                    show: false,
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: '#ddd',
                        width: 1 ,
                        type: 'solid'
                    },
                },
                axisLabel: {
                    fontSize: 11 ,
                    fontStyle: 'normal' ,
                    fontWeight: 500 ,
                    fontFamily: 'Montserrat',
                    color: '#7a7a7a',
                    margin: 10
                },
                type: 'category',
                data: ['Jan 2021', 'Feb 2021', 'Mar 2021', 'Apr 2021', 'May 2021', 'Jun 2021']
                // boundaryGap: false,
                // data: [],
                // scale : true,
                // min:0,
                // max: '',
            },

            market_forecast_chart_series: [],

            market_forecast_chart_yaxis: {
                axisLabel:{
                    formatter: function (value) {
                        return value + '%'
                    },
                    margin: 20
                },
                axisTick: {
                    show: false,
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: '#ddd',
                        width: 1 ,
                        type: 'solid'
                    },
                },
                type: 'value',
                scale : true,
                axisLabel: {
                    show: false,
                },
                splitLine: {
                    show: false,
                    // lineStyle: {
                    //     color: ['#ccc'],
                    //     width: 1,
                    //     type: 'dotted',
                    // }
                },
            },

            market_forecast_chart_xaxis: {
                axisTick: {
                    show: false,
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: '#ddd',
                        width: 1 ,
                        type: 'solid'
                    },
                },
                axisLabel: {
                    show: false,
                },
                type: 'category',
                boundaryGap: false,
                data: ['Jan 2021', 'Feb 2021', 'Mar 2021', 'Apr 2021', 'May 2021', 'Jun 2021'],
                scale : true,
                min:0,
                max: '',
            },

            initOptions : {renderer : 'svg'},
        }
    },

    computed : {
        verifiedKnowledgeChart : function(){
            return {
                title : {
                    show : true,
                    color: '#000',
                    // padding: 20,
                },
                tooltip: {
                    trigger: 'axis',
                    formatter : (params) => {
                        let tooltip = '';

                        for(let i=0; i<params.length; i++){
                            tooltip = tooltip + (`${params[i].name}<br/>${params[i].marker}&nbsp;${params[i].seriesName}: ₹ ${params[i].value} <br />`)
                        }

                        return tooltip;
                    }
                },
                legend: {
                    show: false
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                yAxis: this.verified_knowledge_chart_yaxis,
                xAxis: this.verified_knowledge_chart_xaxis,
                series: this.verified_knowledge_chart_series,
                colors: this.verified_knowledge_chart_colors
            }
        },

        marketForecastChart : function(){
            return {
                title : {
                    show : true,
                    color: '#000',
                    // padding: 20,
                },
                tooltip: {
                    trigger: 'axis',
                    formatter : (params) => (`${params[0].name}<br/><span style="background-color: ${params[0].color}; border-radius: 50px;">&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;${params[0].seriesName}: ₹ ${params[0].value}`)
                },
                legend: {
                    show: false
                },
                // grid: {
                //     left: '3%',
                //     right: '4%',
                //     bottom: '3%',
                //     containLabel: true
                // },
                yAxis: this.market_forecast_chart_yaxis,
                xAxis: this.market_forecast_chart_xaxis,
                series: this.market_forecast_chart_series
            }
        }
    }
}
